import styled from 'styled-components';

import {colors, font} from 'theme';

export const ConfirmRemoveFooter = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 10px;
`;
export const ConfirmBlockMessage = styled.p`
    text-align: center;
    font-family: ${font.family.primary};
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: ${colors.textPrimary};
`;
